import { snakeCase } from 'lodash'
import entityNames from 'options/entityNames'

const fieldSettings = [
  {
    dtoFieldName: 'tag',
    columnHeadingLanguageKey: 'tag',
    columnHeadingTooltipLanguageKey: 'tagColumnTooltip',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 64,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Left',
    displayFormat: 'Text',
  },
  {
    dtoFieldName: 'label',
    columnHeadingLanguageKey: 'label',
    columnHeadingTooltipLanguageKey: '',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 192,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Left',
    displayFormat: 'Text',
  },
  {
    dtoFieldName: 'enabled',
    columnHeadingLanguageKey: 'issue',
    columnHeadingTooltipLanguageKey: '',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 80,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Center',
    displayFormat: 'Text',
  },
  {
    dtoFieldName: 'enabledPurch',
    columnHeadingLanguageKey: 'purchase',
    columnHeadingTooltipLanguageKey: '',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 80,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Center',
    displayFormat: 'Text',
  },
  {
    dtoFieldName: 'enabledAssets',
    columnHeadingLanguageKey: 'assets',
    columnHeadingTooltipLanguageKey: '',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 80,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Center',
    displayFormat: 'Text',
  },
  {
    dtoFieldName: 'required',
    columnHeadingLanguageKey: 'required',
    columnHeadingTooltipLanguageKey: 'requiredTagColumnTooltip',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 80,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Center',
    displayFormat: 'Text',
  },
  {
    dtoFieldName: 'restricted',
    columnHeadingLanguageKey: 'restricted',
    columnHeadingTooltipLanguageKey: 'restrictedTagColumnTooltip',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 80,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Center',
    displayFormat: 'Text',
  },
  {
    dtoFieldName: 'showList',
    columnHeadingLanguageKey: 'showList',
    columnHeadingTooltipLanguageKey: '',
    isDisplayable: true,
    displayByDefault: true,
    columnWidth: 80,
    sortByEnumValue: -1,
    linkTarget: 'none',
    alignment: 'Center',
    displayFormat: 'Text',
  },
]

const entityName = entityNames.customers
const ENTITY_NAME = snakeCase(entityName).toUpperCase()

const childName = 'tagSettings'
const CHILD_NAME = snakeCase(childName).toUpperCase()

export default {
  getSettings: () => ({
    type: `${ENTITY_NAME}_${CHILD_NAME}_SETTINGS_GET`,
    payload: Promise.resolve({ data: { fieldSettings } }),
  }),
}
